import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import MyPlugin from "./plugins/myPlugin";
import '@/plugins/apexcharts'
import firebase from "firebase";
import axios from "axios";
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

import "@basics";

axios.defaults.baseURL = "https://nestjs-le-capt-prod-batemob-nestjs-bxdou0.mo5.mogenius.io/";
// axios.defaults.baseURL = "http://localhost:3000";
axios.defaults.withCredentials = true;
Vue.config.productionTip = false;


Vue.use(VueTelInputVuetify, {
  vuetify,
});

Vue.use(MyPlugin);

const firebaseConfig = {
  apiKey: "AIzaSyCfOEjat6lYAiLpQZAswzs2BtHNlSQuock",
  authDomain: "batemob.firebaseapp.com",
  databaseURL: "httpsfirebaseio.com",
  projectId: "batemob",
  storageBucket: "batemob.appspot.com",
  messagingSenderId: "43693612341",
  appId: "1:43693612341:web:76db884e55b797397a807c",
  measurementId: "G-NJ84TZT5YP",
};

firebase.initializeApp(firebaseConfig);

store.dispatch("auth/refreshToken").then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#le-capteur-francais-app");
});
